import axios from "../../axios"

export const getAmlAnalysisData = async (accountId) => {
    try {
        const resp = await axios.get(`/api/v3/analysis/amlAnalysis?accountId=${accountId}`);
        return resp.data
    } catch (error) {
        throw error
    }
}